export const translations = {
  en: {
    nav: {
      features: 'Features',
      pricing: 'Pricing',
      startTrial: 'Start Free Trial',
      login: 'Login',
      testimonials: 'Testimonials'
    },
    hero: {
      title: 'Revolutionize Your Business with AI-Powered Smart Inventory',
      subtitle: 'Streamline your operations with our advanced inventory management system',
      downloadAndroid: 'Android',
      downloadIOS: 'iPhone',
      trialText: 'Start your 7-day free trial today'
    },
    cta: {
      title: 'Manage Your Business Efficiently',
      subtitle: 'A complete solution for managing your sales, inventory, and customers',
      button: 'Start Free Trial'
    },
    features: {
      title: 'Everything you need to manage your business',
      subtitle: 'Powerful features to help you grow',
      cards: {
        ai: {
          title: 'AI-Powered Insights',
          description: 'Get smart recommendations and predictions to optimize your inventory'
        },
        inventory: {
          title: 'Smart Inventory',
          description: 'Track stock levels in real-time and get automatic reorder alerts'
        },
        printing: {
          title: 'Receipt Printing',
          description: 'Print professional receipts directly from your mobile device'
        },
        analytics: {
          title: 'Advanced Analytics',
          description: 'Make data-driven decisions with detailed reports and insights'
        },
        performance: {
          title: 'Performance Tracking',
          description: 'Monitor sales performance and identify growth opportunities'
        },
        security: {
          title: 'Enhanced Security',
          description: 'Keep your data safe with advanced encryption and backups'
        },
        backup: {
          title: 'Cloud Backup',
          description: 'Never lose your data with automatic cloud synchronization'
        },
        whatsapp: {
          title: 'Daily WhatsApp Reports',
          description: 'Receive automated daily sales reports directly on WhatsApp to stay informed on the go'
        },
        accounting: {
          title: 'Accounting Integration',
          description: 'Automatically track income, expenses, and generate financial reports'
        }
      }
    },
    pricing: {
      title: 'Simple, Transparent Pricing',
      subtitle: 'One plan, all features included',
      monthly: 'Monthly',
      yearly: 'Yearly',
      mostPopular: 'Unique Plan',
      plan: {
        title: 'Genius Vente',
        description: 'Manage your sales simply and efficiently.',
        price: '3',
        month: 'month',
        buttonText: 'Start Free Trial',
        features: [
          'Sales management',
          'Product management',
          'Receipt printing',
          'Sales reports',
          'Mobile access'
        ]
      },
      printer: {
        title: 'Pack Pro',
        description: 'The perfect solution for small businesses ready to level up',
        price: '4.99',
        buttonText: 'Start Free Trial',
        features: [
          'Unlimited inventory items',
          'Real-time analytics dashboard',
          'Cloud backup & sync',
          'Multi-user accounts',
          '24/7 priority support'
        ]
      },
      app: {
        title: 'Pack Elite',
        description: 'The all-in-one package for complete and seamless business management.',
        price: '9.99',
        month: 'month',
        oneTime: 'month',
        buttonText: 'Start Free Trial',
        features: [
          'AI-powered stock analysis (ChatGPT)',
          'Automated WhatsApp notifications',
          'WhatsApp Invoice',
          'Accounting management',
          'Unlimited inventory items',
          'Real-time analytics dashboard',
          'Cloud backup & sync',
          'Multi-user accounts',
          '24/7 priority support'
        ]
      },
      cards: {
        starter: {
          title: 'Starter',
          price: '$29',
          description: 'Perfect for small businesses starting their journey'
        },
        pro: {
          title: 'Pro',
          price: '$79',
          description: 'Ideal for growing businesses needing more features'
        },
        enterprise: {
          title: 'Enterprise',
          price: 'Custom',
          description: 'For large businesses with specific requirements'
        }
      },
      thermalPrinter: {
        title: 'Special Offer',
        description: 'Thermal Printer for only $20',
        subtitle: 'Available exclusively for our clients',
        imagePath: '../assets/print.webp',
        new: 'New',
        recommended: 'Recommended',
        printerLabel: 'Portable Thermal Printer',
        orderButton: 'Order',
        features: {
          fastPrinting: 'Fast Printing',
          appCompatible: 'Compatible with App',
          easyToCarry: 'Easy to Carry',
          bluetoothConnection: 'Bluetooth Connection'
        }
      }
    },
    testimonials: {
      title: 'What Our Customers Say',
      subtitle: 'Discover how Genius Vente helps businesses grow',
      cards: [
        {
          name: "Roxane Djebbelly",
          role: "Owner",
          company: "Fashion Elegance Boutique",
          content: "Genius Vente has revolutionized my store management. The interface is intuitive and the AI features are truly impressive!"
        },
        {
          name: "Luc Lombo",
          role: "Director",
          company: "Tech Solutions Plus",
          content: "Stock management has never been easier. The detailed reports help us make better business decisions."
        },
        {
          name: "Marie Laurent",
          role: "Manager",
          company: "Artists Café",
          content: "Customer support is exceptional and the system is very reliable. It saves us precious time every day."
        }
      ]
    },
    auth: {
      login: 'Login',
      register: 'Register',
      email: 'Email',
      password: 'Password',
      forgotPassword: 'Forgot Password?',
      noAccount: "Don't have an account?",
      hasAccount: 'Already have an account?',
      signUp: 'Sign up',
      signIn: 'Sign in'
    },
    dashboard: {
      welcome: 'Welcome back',
      overview: 'Overview',
      sales: 'Sales',
      inventory: 'Inventory',
      customers: 'Customers',
      reports: 'Reports',
      settings: 'Settings'
    },
    products: 'Products',
    noProducts: 'No products found',
    searchProducts: 'Search products...',
    addProduct: 'Add Product',
    productName: 'Product Name',
    productCode: 'Product Code',
    productDescription: 'Description',
    description: 'Description',
    purchasePrice: 'Purchase Price',
    salePrice: 'Sale Price',
    quantity: 'Quantity',
    inStock: 'In Stock',
    outOfStock: 'Out of Stock',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    confirmDelete: 'Are you sure you want to delete this product?',
    deleteSuccess: 'Product deleted successfully',
    deleteError: 'Error deleting product',
    updateSuccess: 'Product updated successfully',
    updateError: 'Error updating product',
    createSuccess: 'Product created successfully',
    createError: 'Error creating product',
    required: 'This field is required',
    invalidNumber: 'Please enter a valid number',
    sales: 'Sales',
    salesDescription: 'Manage your sales',
    cart: 'Cart',
    emptyCart: 'Your cart is empty',
    total: 'Total',
    checkout: 'Checkout',
    whatsapp: {
      chat: 'Chat',
      message: 'Hello, I would like to know more about Genius Vente.'
    },
    footer: {
      description: 'Smart inventory management and point of sale solution for modern businesses.',
      product: 'Product',
      features: 'Features',
      pricing: 'Pricing',
      download: 'Download',
      support: 'Support',
      documentation: 'Documentation',
      contact: 'Contact',
      faq: 'FAQ',
      legal: 'Legal',
      privacyPolicy: 'Privacy Policy',
      termsOfService: 'Terms of Service',
      allRightsReserved: 'All rights reserved.'
    }
  },
  fr: {
    nav: {
      features: 'Fonctionnalités',
      pricing: 'Tarifs',
      startTrial: 'Essai gratuit',
      login: 'Connexion',
      testimonials: 'Témoignages'
    },
    hero: {
      title: 'Révolutionnez Votre Entreprise avec une Gestion Intelligente par IA',
      subtitle: 'Optimisez vos opérations avec notre système de gestion avancé',
      downloadAndroid: 'Android',
      downloadIOS: 'iPhone',
      trialText: 'Commencez votre essai gratuit de 7 jours'
    },
    cta: {
      title: 'Gérez votre entreprise efficacement',
      subtitle: 'Une solution complète pour la gestion de vos ventes, stocks et clients',
      button: 'Commencer l\'essai gratuit'
    },
    features: {
      title: 'Tout ce dont vous avez besoin pour gérer votre entreprise',
      subtitle: 'Des fonctionnalités puissantes pour vous aider à grandir',
      cards: {
        ai: {
          title: 'IA Intelligente',
          description: 'Obtenez des recommandations et prédictions pour optimiser votre inventaire'
        },
        inventory: {
          title: 'Inventaire Intelligent',
          description: 'Suivez les niveaux de stock en temps réel avec alertes de réapprovisionnement'
        },
        printing: {
          title: 'Impression de Reçus',
          description: 'Imprimez des reçus professionnels directement depuis votre mobile'
        },
        analytics: {
          title: 'Analyses Avancées',
          description: 'Prenez des décisions basées sur des rapports et analyses détaillés'
        },
        performance: {
          title: 'Suivi de Performance',
          description: 'Surveillez les performances de vente et identifiez les opportunités'
        },
        security: {
          title: 'Sécurité Renforcée',
          description: 'Protégez vos données avec cryptage avancé et sauvegardes'
        },
        backup: {
          title: 'Sauvegarde Cloud',
          description: 'Ne perdez jamais vos données avec la synchronisation automatique'
        },
        whatsapp: {
          title: 'Rapports WhatsApp Quotidiens',
          description: "L'application envoie le rapport de vente de chaque jour sur WhatsApp pour rester informé en permanence"
        },
        accounting: {
          title: 'Intégration Comptable',
          description: 'Suivez automatiquement les revenus, les dépenses et générez des rapports financiers'
        }
      }
    },
    pricing: {
      title: 'Tarification Simple et Transparente',
      subtitle: 'Un seul plan, toutes les fonctionnalités incluses',
      monthly: 'Mensuel',
      yearly: 'Annuel',
      mostPopular: 'Forfait Unique',
      plan: {
        title: 'Genius Vente',
        description: 'Gérez vos ventes simplement et efficacement.',
        price: '3',
        month: 'mois',
        buttonText: 'Essai Gratuit',
        features: [
          'Gestion des ventes',
          'Gestion des produits',
          'Impression des reçus',
          'Rapports de ventes',
          'Accès mobile'
        ]
      },
      printer: {
        title: 'Pack Pro',
        description: 'La solution idéale pour les petits commerces qui veulent passer à la vitesse supérieure.',
        price: '4,99',
        buttonText: 'Essai Gratuit',
        features: [
          'Articles en stock illimités',
          'Tableau de bord analytique en temps réel',
          'Sauvegarde et synchronisation dans le cloud',
          'Comptes multi-utilisateurs',
          'Support prioritaire 24h/24 et 7j/7'
        ]
      },
      app: {
        title: 'Pack Elite',
        description: 'La formule tout-en-un pour une gestion complète et fluide de votre commerce.',
        price: '9,99',
        month: 'mois',
        oneTime: 'mois',
        buttonText: 'Essai Gratuit',
        features: [
          "Analyse de stock alimentée par l'IA (ChatGPT)",
          'Notifications automatiques via WhatsApp',
          'Facture via WhatsApp',
          'Gestion de la comptabilité',
          'Articles en stock illimités',
          'Tableau de bord en temps réel',
          'Sauvegarde et synchronisation cloud',
          'Comptes multi-utilisateurs',
          'Support prioritaire 24/7'
        ]
      },
      cards: {
        starter: {
          title: 'Débutant',
          price: '29€',
          description: 'Parfait pour les petites entreprises qui démarrent'
        },
        pro: {
          title: 'Pro',
          price: '79€',
          description: 'Idéal pour les entreprises en croissance nécessitant plus de fonctionnalités'
        },
        enterprise: {
          title: 'Entreprise',
          price: 'Sur mesure',
          description: 'Pour les grandes entreprises avec des besoins spécifiques'
        }
      },
      thermalPrinter: {
        title: 'Offre Spéciale',
        description: 'Imprimante Thermique pour seulement 20$',
        subtitle: 'Disponible exclusivement pour nos clients',
        imagePath: 'assets/print.webp',
        new: 'Nouveau',
        recommended: 'Recommandé',
        printerLabel: 'Imprimante thermique portable',
        orderButton: 'Commander',
        features: {
          fastPrinting: 'Impression rapide',
          appCompatible: 'Compatible avec l\'application',
          easyToCarry: 'Facile à transporter',
          bluetoothConnection: 'Connexion Bluetooth'
        }
      }
    },
    testimonials: {
      title: 'Ce que nos clients disent',
      subtitle: 'Découvrez comment Genius Vente aide les entreprises à se développer',
      cards: [
        {
          name: "Sarah Martin",
          role: "Propriétaire",
          company: "Boutique Mode Élégance",
          content: "Genius Vente a révolutionné la gestion de ma boutique. L'interface est intuitive et les fonctionnalités d'IA sont vraiment impressionnantes !"
        },
        {
          name: "Thomas Dubois",
          role: "Directeur",
          company: "Tech Solutions Plus",
          content: "La gestion des stocks n'a jamais été aussi simple. Les rapports détaillés nous aident à prendre de meilleures décisions commerciales."
        },
        {
          name: "Marie Laurent",
          role: "Gérante",
          company: "Café des Artistes",
          content: "Le support client est exceptionnel et le système est très fiable. Cela nous fait gagner un temps précieux au quotidien."
        }
      ]
    },
    auth: {
      login: 'Connexion',
      register: 'Inscription',
      email: 'Email',
      password: 'Mot de passe',
      forgotPassword: 'Mot de passe oublié ?',
      noAccount: "Vous n'avez pas de compte ?",
      hasAccount: 'Vous avez déjà un compte ?',
      signUp: "S'inscrire",
      signIn: 'Se connecter'
    },
    dashboard: {
      welcome: 'Bienvenue',
      overview: 'Aperçu',
      sales: 'Ventes',
      inventory: 'Inventaire',
      customers: 'Clients',
      reports: 'Rapports',
      settings: 'Paramètres'
    },
    products: 'Produits',
    noProducts: 'Aucun produit trouvé',
    searchProducts: 'Rechercher des produits...',
    addProduct: 'Ajouter un Produit',
    productName: 'Nom du Produit',
    productCode: 'Code du Produit',
    productDescription: 'Description',
    description: 'Description',
    purchasePrice: 'Prix d\'Achat',
    salePrice: 'Prix de Vente',
    quantity: 'Quantité',
    inStock: 'En Stock',
    outOfStock: 'Rupture de Stock',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce produit ?',
    deleteSuccess: 'Produit supprimé avec succès',
    deleteError: 'Erreur lors de la suppression du produit',
    updateSuccess: 'Produit mis à jour avec succès',
    updateError: 'Erreur lors de la mise à jour du produit',
    createSuccess: 'Produit créé avec succès',
    createError: 'Erreur lors de la création du produit',
    required: 'Ce champ est requis',
    invalidNumber: 'Veuillez entrer un nombre valide',
    sales: 'Ventes',
    salesDescription: 'Gérer vos ventes',
    cart: 'Panier',
    emptyCart: 'Votre panier est vide',
    total: 'Total',
    checkout: 'Finaliser la vente',
    whatsapp: {
      chat: 'Chat',
      message: 'Bonjour, je souhaite en savoir plus sur Genius Vente.'
    },
    footer: {
      description: 'Solution intelligente de gestion de stock et de point de vente pour les entreprises modernes.',
      product: 'Produit',
      features: 'Fonctionnalités',
      pricing: 'Tarifs',
      download: 'Télécharger',
      support: 'Support',
      documentation: 'Documentation',
      contact: 'Contact',
      faq: 'FAQ',
      legal: 'Mentions légales',
      privacyPolicy: 'Politique de confidentialité',
      termsOfService: 'Conditions d\'utilisation',
      allRightsReserved: 'Tous droits réservés.'
    }
  }
};